import {useAppContext} from "../../utils/AppContext";
import bg_lines from "../../assets/images/maze_bg_lines_1.svg";

const Background = () => {
    const {
        screenSize
    } = useAppContext();
    
    return (
        <div className="home-background">
            <img 
                className={`home-background-image-1${screenSize}`}
                src={bg_lines} 
                alt="Home Background"
            />
            <img 
                className={`home-background-image-2${screenSize}`}
                src={bg_lines} 
                alt="Home Background"
            />
            <div className="home-background-noise"/>
        </div>
    );

};

export default Background;
